import React, { useState } from "react";
import { isAuthenticated } from "../apiCallsHelper/authapicalls";
import { createTodo } from "../apiCallsHelper/todoapicalls";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../styles.css";
import LoadingOverlay from "./../utils/LoadingOverlay";

const TodoForm = ({ setIsSubmitted, setIsTodos, setIsTasksAvailable }) => {
  const { user, token } = isAuthenticated();

  const [todo, setTodo] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true);
    createTodo(user._id, token, { title: todo }).then((data) => {
      if (data.error) {
        setIsLoading(false);
        setTodo("");
        toast.error(data.error, {
          theme: "colored",
          style: { width: "240px", marginLeft: "70px" },
        });
      } else {
        toast.success(data.message, {
          theme: "colored",
          style: { width: "200px", marginLeft: "120px" },
        });
        setIsLoading(false);
        setTodo("");
        setIsSubmitted(true);
        setIsTodos(true);
        setIsTasksAvailable(false);
      }
    });
  };

  return (
    <>
      <div className="h-[300px]">
        <div className="w-[280px]  xs:w-[355px]  sm:w-[475px]  mobLg:w-[580px]   md:w-[440px] smLaptop:w-[560px]  lg:w-[740px] xl:w-[822px]">
          {isLoading && <LoadingOverlay />}
          <form
            onSubmit={handleSubmit}
            className="    px-14 pt-10 pb-14 mb-4    xs:px-14 xs:pt-10 xs:pb-14 xs:mb-4    mobSm:px-10 mobSm:pt-10 mobSm:pb-14 mobSm:mb-4    sm:px-24 sm:pt-10 sm:pb-8 sm:mb-4   mobLg:px-20 mobLg:pt-10 mobLg:pb-8 mobLg:mb-4    md:w-[430px] md:px-20 md:pt-6 md:pb-8 md:mb-4    smLaptop:w-[560px] smLaptop:h-[280px] smLaptop:px-20 smLaptop:pt-14 smLaptop:pb-8 smLaptop:mb-2    lg:w-[730px] lg:h-[270px] lg:px-40 lg:pt-6 lg:pb-8 lg:mb-4   xl:h-[270px] xl:w-[815px]   bg-white shadow-md rounded"
          >
            <div className="mb-4 ">
              <label
                className="block text-[#356496] text-[30px] font-bold mb-2 "
                htmlFor="todo-form-title"
              >
                Todo
              </label>
              <input
                className="mt-2 shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline "
                id="todo-form-title"
                type="text"
                placeholder="Please enter title..."
                value={todo}
                onChange={(event) => setTodo(event.target.value)}
              />
            </div>
            <div className="mt-8 flex items-center justify-between">
              <button
                type="submit"
                className="bg-[#8aabff] hover:bg-[#5772b3] text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
              >
                Add Todo
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default TodoForm;
